import { render } from "./App.vue?vue&type=template&id=828b6788"
const script = {}

import "./App.vue?vue&type=style&index=0&id=828b6788&lang=css"
script.render = render

export default script